import { render, staticRenderFns } from "./12.vue?vue&type=template&id=3c798c1e&scoped=true&"
import script from "./12.vue?vue&type=script&lang=js&"
export * from "./12.vue?vue&type=script&lang=js&"
import style0 from "./12.vue?vue&type=style&index=0&id=3c798c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c798c1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
